import React, { useEffect } from 'react';
import { Card, Col } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { TooltipHost } from '@fluentui/react';
import { useState } from 'react';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { formatNumber, isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';

function POWERBI_COMPONENT_OCR(props) {
    const { t } = useTranslation();

    const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);

    const { 
        inputParam_HideHeader = false,
        inputParam_ComponentContent = null,
        inputParam_BoardStructure = null,
        inputParam_Container = null,
    } = props;

    const _baseSeries = [
        {
            id: 1,
            name: t("data-lang-lbl-field-displayValue"),
            type: "column",
            data: inputParam_ComponentContent?.items.length > 0 ? (inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.map(({ displayValue }) => displayValue) : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.map(({ displayValue }) => displayValue) : [])) : [],
            dataColor: inputParam_ComponentContent?.items.length > 0 ? (inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.map(({ color }) => color) : (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ? inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.map(({ color }) => color) : [])) : []
        }
    ]
    const [loadComplete, setLoadComplete] = useState(false)
    const [loading, setLoading] = useState(false)

    const [chartDataConfig, setChartDataConfig] = useState({
        listSeriesX: inputParam_ComponentContent ? _baseSeries : [],
        listSerieTimeY: inputParam_ComponentContent?.items.length > 0 ? (inputParam_ComponentContent.items[0].l_vals !== undefined ?
            inputParam_ComponentContent.items[0].l_vals.map(({ serieTimeStr }) => serieTimeStr) :
            (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ?
                inputParam_ComponentContent.items[0].l_dataserie[0].l_vals.map(({ serieTimeStr, serieTime }) => serieTimeStr !== null ? serieTimeStr : serieTime) :
                [])) : [],
        _baseSerieNames: [{
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            tickAmount: 5,
            min: 0,
            max: Math.pow(10, Math.floor(Math.log10(Math.max(..._baseSeries.filter(o => o.id === 1 || o.id === 2).flatMap(o => o.data))))) * Math.ceil(Math.max(..._baseSeries.filter(o => o.id === 1 || o.id === 2).flatMap(o => o.data)) / Math.pow(10, Math.floor(Math.log10(Math.max(..._baseSeries.filter(o => o.id === 1 || o.id === 2).flatMap(o => o.data)))))),
            labels: {
                //show: false,
                formatter: function (val) { return parseInt(val.toFixed(0)).toLocaleString(); },
            },
            tooltip: {
                enabled: true,
                y: { formatter: (val) => parseInt(val.toFixed(0)).toLocaleString() }
            },
            title: {
                text: t("data-lang-lbl-field-displayValue"),
                style: { color: '#1F7BE8' }
            }
        }],
    });
    
    const getTitleSubTitle = () => {

        let title = '';
        let subtitle = '';

        
        if (boardVariableDataserieValues !== null && inputParam_ComponentContent !== null) {
            if ( (inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.length > 0) && inputParam_ComponentContent.items[0].l_dataserie !== undefined && inputParam_ComponentContent.items[0].l_dataserie.length > 0) {
                const item = boardVariableDataserieValues.find(x => x.dataserieId === (inputParam_ComponentContent.items[0].l_dataserie[0].newDataSerieId));
                title = !isNullUndefinedOrEmpty(item) ? item.variableName : "";
                subtitle = !isNullUndefinedOrEmpty(item) ? item.um : "";
            }
            if (inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.l_dataserie !== undefined && inputParam_ComponentContent.items.l_dataserie.length > 0) {
                const item = boardVariableDataserieValues.find(x => x.dataserieId === (inputParam_ComponentContent.items.l_dataserie[0].newDataSerieId))
                title = !isNullUndefinedOrEmpty(item) ? item.variableName : "";
                subtitle = !isNullUndefinedOrEmpty(item) ? item.um : "";
            }
        }

        return { title: title, subtitle: subtitle }
    }

    const objTitles = getTitleSubTitle()

    const aux_title = inputParam_ComponentContent && inputParam_ComponentContent.items.length > 0 ?
                            (inputParam_ComponentContent.items[0].l_dataserie !== undefined ?
                                (inputParam_ComponentContent.items[0].l_dataserie.length > 0 ?
                                    inputParam_ComponentContent.items[0].l_dataserie[0].variableName : ""
                                ) : ""
                            ): "";

    useEffect(() => {
        if (!isNullUndefined(inputParam_ComponentContent) && !loadComplete) {
           setLoadComplete(true);
        }
    }, [inputParam_ComponentContent]);

    return  <Card className='board-element-form h-100'>
                {
                    inputParam_ComponentContent && inputParam_ComponentContent.items.length > 0 && chartDataConfig.listSeriesX && chartDataConfig.listSerieTimeY && chartDataConfig._baseSerieNames &&
                    <>
                        {
                            !inputParam_HideHeader &&
                            <Card.Header className="card-header-compact">
                                <Card.Title className="d-flex justify-content-between">
                                        {
                                            !isNullUndefinedOrEmpty(inputParam_ComponentContent) && !isNullUndefinedOrEmpty(inputParam_ComponentContent.boardComponentTitle) &&
                                            <b>{ inputParam_ComponentContent.boardComponentTitle }</b>
                                        }
                                        {
                                            !isNullUndefinedOrEmpty(inputParam_ComponentContent) && isNullUndefinedOrEmpty(inputParam_ComponentContent.boardComponentTitle) &&
                                            <b>{!isNullUndefinedOrEmpty(aux_title) ? aux_title : t('data-lang-lbl-chart')}</b>
                                        }
                                    <div className='toolbar d-flex'>
                                        <HEADER_TOOLBAR
                                            inputParam_BoardStructure={inputParam_BoardStructure}
                                            inputParam_Container={inputParam_Container}
                                        />
                                    </div>
                                </Card.Title>
                            </Card.Header>
                        }
                        <Card.Body className='h-100 px-2 pt-2'>
                        {
                            inputParam_ComponentContent ?
                                <div className='px-3 h-100 d-flex'>
                                    <Col>
                                        <ReactApexChart
                                            id={"powerbi-chart-to-export-" + inputParam_ComponentContent.boardComponentInfoId}
                                            type="bar"
                                            series={ chartDataConfig.listSeriesX }
                                            options={{
                                                chart: {
                                                    id: "powerbi-chart-to-export-" + inputParam_ComponentContent.boardComponentInfoId,
                                                    height: 350,
                                                    type: 'bar',
                                                },
                                                plotOptions: {
                                                    bar: {
                                                        borderRadius: 10,
                                                        dataLabels: {
                                                                position: 'top', // top, center, bottom
                                                        },
                                                        /*colors: {
                                                            ranges: [
                                                                { from: 0, to: 99, color: '#D64550' },
                                                                { from: 100, to: 10000, color: '#04A820' },
                                                            ]
                                                        }*/
                                                    }
                                                },
                                                colors: [
                                                    ({ dataPointIndex, w }) => {
                                                        const item = chartDataConfig.listSeriesX[0].dataColor[dataPointIndex]; 

                                                        switch (item) {
                                                            case "r": return "#ff0000"; // rojo
                                                            case "a": return "#F2C037"; // amarillo
                                                            case "v": return "#008000"; // verde
                                                            default: return "#1F7BE8";  // fallback
                                                        }
                                                    }
                                                ],
                                                dataLabels: {
                                                    enabled: true,
                                                    formatter: function (val) {
                                                        return formatNumber(val);
                                                    },
                                                    offsetY: -20,
                                                    style: {
                                                        fontSize: '12px',
                                                        colors: ["#304758"]
                                                    }
                                                },
                                                xaxis: {
                                                    title: {
                                                        text: 'Meses'
                                                    },
                                                    categories: chartDataConfig.listSerieTimeY,
                                                    labels: {
                                                        rotate: -45,
                                                        style: { fontSize: '11px' },
                                                    },
                                                    position: 'bottom',
                                                    axisBorder: {
                                                        show: false
                                                    },
                                                    axisTicks: {
                                                        show: false
                                                    },
                                                    crosshairs: {
                                                        fill: {
                                                            type: 'gradient',
                                                            gradient: {
                                                                colorFrom: '#D8E3F0',
                                                                colorTo: '#BED1E6',
                                                                stops: [0, 100],
                                                                opacityFrom: 0.4,
                                                                opacityTo: 0.5,
                                                            }
                                                        }
                                                    },
                                                    tooltip: {
                                                        enabled: true,
                                                    }
                                                },
                                                yaxis: chartDataConfig._baseSerieNames,
                                                title: {
                                                    text: objTitles.subtitle,
                                                    align: 'center',
                                                    style: {
                                                        color: '#444'
                                                    }
                                                },
                                                tooltip: {
                                                    fixed: {
                                                        enabled: true,
                                                        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                                                        offsetY: 30,
                                                        offsetX: 60
                                                    },
                                                },
                                                legend: {
                                                    horizontalAlign: 'center',
                                                    offsetX: 40
                                                },
                                                responsive: [{
                                                    breakpoint: undefined,
                                                    options: {},
                                                }]
                                            }}
                                            height={"100%"}
                                        />
                                    </Col>
                                </div>
                                : <NoDataLayer display={ true } />
                            }
                        </Card.Body>
                    </>
                }
            </Card>
}

POWERBI_COMPONENT_OCR.propTypes = {
    inputParam_Height: PropTypes.number,
    inputParam_ReportMode: PropTypes.bool,
};

export default POWERBI_COMPONENT_OCR;